import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/list/styles.scss';export default {
  "list": "_list_13sjj_1",
  "hovered": "_hovered_13sjj_6",
  "unScheduled": "_unScheduled_13sjj_9",
  "project": "_project_13sjj_9",
  "completed": "_completed_13sjj_18",
  "nameWrapper": "_nameWrapper_13sjj_32",
  "name": "_name_13sjj_32"
};